import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialog({
  open,
  handleClose,
  searchFromBackend,
  content,
  btnText,
}) {
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ color: "red" }}>
          {"¿Estás seguro de que quieres continuar?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="alertBtn">
            {btnText}
          </Button>
          <Button
            onClick={() => {
              searchFromBackend();
              handleClose();
            }}
            autoFocus
            variant="alertBtn"
          >
            Continuar buscando
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
